import { latestGossip } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function LatestGossip() {
  return (
    <section id="gossip" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="最新八卦"
          title="扒一扒：把最热的那几个问题讲清楚"
          desc="不堆料、不喊口号，只把大家追问最多的问题摊开来聊，看完再决定要不要站队。"
        />

        <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {latestGossip.map((item) => (
            <article key={item.id} className="flex flex-col gap-4 p-5 md:flex-row md:gap-6 md:p-6">
              <div className="flex shrink-0 items-start gap-3 md:w-40 md:flex-col md:gap-2">
                <span className="font-heading text-3xl leading-none text-primary-300 md:text-4xl">
                  {item.index}
                </span>
                <span className="mt-1 flex items-center gap-1.5 text-xs text-foreground-500 md:mt-0">
                  <i className="ri-user-3-line"></i>
                  {item.author}
                </span>
              </div>

              <div className="min-w-0 flex-1">
                <h3 className="text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {item.question}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1 transition hover:text-primary-600">
                    <i className="ri-chat-1-line"></i>
                    进入讨论
                  </span>
                  <span className="flex items-center gap-1 transition hover:text-primary-600">
                    <i className="ri-bookmark-line"></i>
                    追这条
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}